module.exports = __webpack_public_path__ + "static/img/3.3b6fd1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/3.jpg
// module id = ION4
// module chunks = 16